import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';
import getLocale from '../../i18n/getLocale';



class AircraftBasesAdd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      aircraft_models: [],
      bases: [],
      aircraft_bases: [],
      designations_1p: [],
      designations_2p: [],
      designations_3p: [],
      date_start: '0000-00-00',
      aircraft_id: null,
      base_id: null,
      availability: 0,
      reason: null,
      available_date: null,
      indisp_date: null,
      mechanic: null,
      observations: null,
      flight_following: 0,
      flight_following_reason: null,
      flight_following_date: null,
      designation_1p: '',
      designation_2p: '',
      designation_3p: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.clearSelects = this.clearSelects.bind(this);
    this.clearReason = this.clearReason.bind(this);

    this.locale = getLocale();

    this.refreshAircraftBases = this.refreshAircraftBases.bind(this);
    this.loadData = this.loadData.bind(this);
    this.delete = this.delete.bind(this);
    this.add = this.add.bind(this);
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleToggleChangeFlightFollowing (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
      change[name] = value;
      this.setState(change);
    } else {
      var value = 0;
      change[name] = value;
      this.setState(change, ()=> {
        this.clearSelects();
      });
    }
  }
  handleToggleChangeAvailability (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
      change[name] = value;
      this.setState(change, ()=> {
        this.clearReason();
      });
    } else {
      var value = 0;
      change[name] = value;
      this.setState(change);
    }
  }

  //Ao trocar aeronava, listamos tripulantes do mesmo tipo de operação.
  handleSelectChangeAircraft(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;

      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/funcionarios/aeronave/operacao/lista/' + event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({designations_1p: responseJson.data.designations_1p});
            self.setState({designations_2p: responseJson.data.designations_2p});
            self.setState({designations_3p: responseJson.data.designations_3p});
          }
          self.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  clearSelects() {
    this.setState({flight_following_reason: null});
    this.setState({flight_following_date: null});
  }
  clearReason() {
    this.setState({reason: ''});
    this.setState({available_date: ''});
    this.setState({indisp_date: ''});
  }

  // Setamos o state.date_start para a data de hoje
  componentWillMount () {
      var date_start = new Date().toISOString().slice(0,10).split('-').reverse().join('/');
      this.setState({date_start: date_start});
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;

    var datasave = {
      date_start: this.state.date_start,
    };
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/frotas/disponiveis', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if (responseJson.status === 'success') {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({aircraft_bases: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/aeronaves/modelo/registro/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({aircraft_models: responseJson.data});
        }
      var url = config.get('api') + '/usuario/bases/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({bases: responseJson.data});
        }
      var url = config.get('api') + '/funcionarios/comandantes/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({designations_1p: responseJson.data});
        }
      var url = config.get('api') + '/funcionarios/copilotos/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({designations_2p: responseJson.data});
        }
      var url = config.get('api') + '/funcionarios/comissarios/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({designations_3p: responseJson.data});
        }
      var url = config.get('api') + '/frotas/disponiveis/motivos/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({flight_following_reasons: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */ }); /* aeronaves lista */ }); /* bases lista */ }); /* Funcionários 1p */ }); /* Funcionários 2p */ }); /* Funcionários 3p */}); /* lista de motivos 3p */
    });
  }

  add(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      date_start: this.state.date_start,
      aircraft_id: this.state.aircraft_id,
      base_id: this.state.base_id,
      availability: this.state.availability,
      reason: this.state.reason,
      available_date: this.state.available_date,
      indisp_date: this.state.indisp_date,
      mechanic: this.state.mechanic,
      observations: this.state.observations,
      flight_following: this.state.flight_following,
      flight_following_reason: this.state.flight_following_reason,
      flight_following_date: this.state.flight_following_date,
      designation_1p: this.state.designation_1p,
      designation_2p: this.state.designation_2p,
      designation_3p: this.state.designation_3p,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/frota/disponivel', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.refreshAircraftBases(responseJson);
        } else {
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  refreshAircraftBases(event) {
    var self = this;
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var datasave = {
      date_start: this.state.date_start,
    };

    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/frotas/disponiveis', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if (responseJson.status === 'success') {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({aircraft_bases: responseJson.data});
        }
        self.handleAlert(event.message, event.status, 'open');
      }).then(() => {
      }); /* Overlay */
    });
  }

  delete (event) {
    var aircraft_base_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Frotas.AdicionarFrota.deletar);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/frota/disponivel/' + aircraft_base_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.refreshAircraftBases(responseJson);
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }
  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Frotas.AdicionarFrota.titulo} - {this.state.date_start}</h3>
      <Link to="/frotas/disponiveis" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.Frotas.AdicionarFrota.botaoEditarStatus}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Frotas.AdicionarFrota.formulario.Base}</label>
              <Select
                className=""
                name="base_id"
                value={this.state.base_id}
                searchable={true}
                placeholder={this.locale.Frotas.AdicionarFrota.formulario.placeholder.SelecionarBase}
                onChange={this.handleSelectChange.bind(this, 'base_id')}
                options={this.state.bases}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Frotas.AdicionarFrota.formulario.Aeronave}: </label>
              <Select
                className=""
                name="aircraft_id"
                value={this.state.aircraft_id}
                searchable={true}
                placeholder={this.locale.Frotas.AdicionarFrota.formulario.placeholder.SelecionarFrota}
                onChange={this.handleSelectChangeAircraft.bind(this, 'aircraft_id')}
                options={this.state.aircraft_models}
              />
            </div>
           </div>
        </div>
        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>{this.locale.Frotas.AdicionarFrota.formulario.Disponivel}?</label>
              <br/>
              <Toggle
                checked={this.state.availability}
                aria-label=''
                name="availability"
                onChange={this.handleToggleChangeAvailability.bind(this, 'availability')} />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{this.locale.Frotas.AdicionarFrota.formulario.Motivo}:</label>
              <input type="text" name="reason" className="form-control" disabled={this.state.availability === 1 ? "disabled" : ""} placeholder="" value={this.state.reason} onChange={this.handleChange.bind(this, 'reason')} />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{this.locale.Frotas.AdicionarFrota.formulario.Previsao}:</label>
              <InputMask value={this.state.available_date} disabled={this.state.availability === 1 ? "disabled" : ""}  maskChar={null} name="available_date" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'available_date')} placeholder="" />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{this.locale.Frotas.AdicionarFrota.formulario.IndisponivelDesde}:</label>
              <InputMask value={this.state.indisp_date} disabled={this.state.availability === 1 ? "disabled" : ""}  maskChar={null} name="indisp_date" mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'indisp_date')} placeholder="" />
            </div>
           </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Frotas.AdicionarFrota.formulario.InspetorMecanico}:</label>
              <br/>
              <input type="text" name="mechanic" className="form-control" placeholder="" value={this.state.mechanic} onChange={this.handleChange.bind(this, 'mechanic')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Frotas.AdicionarFrota.formulario.Comandantes}:</label>
              <Select
                className=""
                name="designation_1p"
                value={this.state.designation_1p}
                searchable={true}
                placeholder={''}
                multi={true}
                onChange={this.handleSelectChange.bind(this, 'designation_1p')}
                options={this.state.designations_1p}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Frotas.AdicionarFrota.formulario.Copilotos}:</label>
              <Select
                className=""
                name="designation_2p"
                value={this.state.designation_2p}
                searchable={true}
                placeholder={''}
                multi={true}
                onChange={this.handleSelectChange.bind(this, 'designation_2p')}
                options={this.state.designations_2p}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Frotas.AdicionarFrota.formulario.Comissarios}:</label>
              <Select
                className=""
                name="designation_3p"
                value={this.state.designation_3p}
                searchable={true}
                placeholder={''}
                multi={true}
                onChange={this.handleSelectChange.bind(this, 'designation_3p')}
                options={this.state.designations_3p}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Frotas.AdicionarFrota.formulario.FlightFollowingAnormal}?</label>
              <br/>
              <Toggle
                checked={this.state.flight_following}
                aria-label=''
                name="flight_following"
                onChange={this.handleToggleChangeFlightFollowing.bind(this, 'flight_following')} />
            </div>
          </div>
          {(self.state.flight_following == 0) ?
             ""
            :
            <div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>{this.locale.Frotas.AdicionarFrota.formulario.Motivo}:</label>
                  <Select
                    className=""
                    name="flight_following_reason"
                    value={this.state.flight_following_reason}
                    searchable={true}
                    placeholder={''}
                    onChange={this.handleSelectChange.bind(this, 'flight_following_reason')}
                    options={this.state.flight_following_reasons}
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>{this.locale.Frotas.AdicionarFrota.formulario.Desde}:</label>
                  <InputMask value={this.state.flight_following_date}  maskChar={null} name="flight_following_date" mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'flight_following_date')} placeholder="" />
                </div>
              </div>
            </div>
          }
        </div>
        <div className="form-group">
          <label>{this.locale.Frotas.AdicionarFrota.formulario.Observacoes}:</label>
          <textarea style={{ height: 200 }} type="text" name="observations" className="form-control" value={this.state.observations} onChange={this.handleChange.bind(this, 'observations')} />
        </div>
        <hr/>
        <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-save"></i> Salvar frota</button>
      </form>
      {Object.keys(self.state.aircraft_bases).map(function(operation_type) {
        return (
          <div>
            <h4>{operation_type}</h4>
            <ul>
              {Object.keys(self.state.aircraft_bases[operation_type]).map(function(base) {
                return (
                  <div>
                    <h4>{base}</h4>
                    <ul>
                      {Object.keys(self.state.aircraft_bases[operation_type][base]).map(function(k) {
                        return (
                          <div>
                            <li>-
                              <strong> {self.state.aircraft_bases[operation_type][base][k].aircraft.registration} - {self.state.aircraft_bases[operation_type][base][k].aircraft.aircraft_model.consider_weight === 1 && <span>{this.locale.Frotas.AdicionarFrota.listaFrotas.PMD} {self.state.aircraft_bases[operation_type][base][k].aircraft.weight_str} T - </span>} {self.state.aircraft_bases[operation_type][base][k].aircraft.aircraft_model.model}</strong> <button className="btn btn-sm btn-danger" value={self.state.aircraft_bases[operation_type][base][k].id} onClick={self.delete}><i className="fa fa-fw fa-trash"></i></button></li>
                            {(self.state.aircraft_bases[operation_type][base][k].availability == 1) ?
                              <li>- <strong>{this.locale.Frotas.AdicionarFrota.listaFrotas.Disponivel}:</strong> <span className="label label-primary">{self.state.aircraft_bases[operation_type][base][k].availability_str}</span></li>
                              : <div>
                                  <li>- <strong>{this.locale.Frotas.AdicionarFrota.listaFrotas.Disponivel}:</strong> <span className="label label-danger">{self.state.aircraft_bases[operation_type][base][k].availability_str}</span></li>
                                  <li>- <strong>{this.locale.Frotas.AdicionarFrota.listaFrotas.Motivo}:</strong> <span className="label label-danger">{self.state.aircraft_bases[operation_type][base][k].reason}</span></li>
                                  <li>- <strong>{this.locale.Frotas.AdicionarFrota.listaFrotas.Previsao}:</strong> <span className="label label-danger">{self.state.aircraft_bases[operation_type][base][k].available_date}</span></li>
                                  <li>- <strong>{this.locale.Frotas.AdicionarFrota.listaFrotas.IndisponivelDesde}:</strong> <span className="label label-danger">{self.state.aircraft_bases[operation_type][base][k].indisp_date}</span></li>
                                </div>
                            }
                            <li>- <strong>{this.locale.Frotas.AdicionarFrota.listaFrotas.AdicionadoPor}:</strong> {self.state.aircraft_bases[operation_type][base][k].user.name}</li>
                            <li>- <strong>{this.locale.Frotas.AdicionarFrota.listaFrotas.InspetorMecanico}:</strong> {self.state.aircraft_bases[operation_type][base][k].mechanic}</li>
                            {(self.state.aircraft_bases[operation_type][base][k].flight_following_str == 'Normal') ?
                              <li>- <strong>{this.locale.Frotas.AdicionarFrota.listaFrotas.FlightFollowing}:</strong> <span className="label label-primary">{self.state.aircraft_bases[operation_type][base][k].flight_following_str}</span></li>
                              : <li>- <strong>{this.locale.Frotas.AdicionarFrota.listaFrotas.FlightFollowing}:</strong> <span className="label label-danger">{self.state.aircraft_bases[operation_type][base][k].flight_following_str}</span> - {self.state.aircraft_bases[operation_type][base][k].flight_following_reason} - {this.locale.general.desde}: {self.state.aircraft_bases[operation_type][base][k].flight_following_date_str} </li>
                            }
                            {(self.state.aircraft_bases[operation_type][base][k].observations !== null) ?
                              <li>- <strong>{this.locale.Frotas.AdicionarFrota.listaFrotas.Observacoes}:</strong> {self.state.aircraft_bases[operation_type][base][k].observations}</li>
                              : ""
                            }
                            <br/>
                            {(self.state.aircraft_bases[operation_type][base][k].designation_1p !== null) ?
                              <li>- <strong>{this.locale.Frotas.AdicionarFrota.listaFrotas.Comandantes}:</strong> {self.state.aircraft_bases[operation_type][base][k].designation_1p}</li>
                              : ""
                            }
                            {(self.state.aircraft_bases[operation_type][base][k].designation_2p !== null) ?
                              <li>- <strong>{this.locale.Frotas.AdicionarFrota.listaFrotas.Copilotos}:</strong> {self.state.aircraft_bases[operation_type][base][k].designation_2p}</li>
                              : ""
                            }
                            {(self.state.aircraft_bases[operation_type][base][k].designation_3p !== null) ?
                              <li>- <strong>{this.locale.Frotas.AdicionarFrota.listaFrotas.Comissarios}:</strong> {self.state.aircraft_bases[operation_type][base][k].designation_3p}</li>
                              : ""
                            }
                            <hr/>
                          </div>
                        );
                      })}
                    </ul>
                    <hr/>
                  </div>
                );
              })}
            </ul>
            <hr/>
          </div>
        );
      })}
    </div>
  </div>
</div>
    );
  }
}

export default AircraftBasesAdd;



// WEBPACK FOOTER //
// ./src/Components/AircraftBases/AircraftBasesAdd.js